import { default as about_45us6Wta0rHXEGMeta } from "D:/oneway/machine-web/pages/about-us.vue?macro=true";
import { default as company_45profileHjzlV7Evv4Meta } from "D:/oneway/machine-web/pages/about-us/company-profile.vue?macro=true";
import { default as factory_45production4VeLh2tqinMeta } from "D:/oneway/machine-web/pages/about-us/factory-production.vue?macro=true";
import { default as faqEeJT1m2LGhMeta } from "D:/oneway/machine-web/pages/about-us/faq.vue?macro=true";
import { default as index68OmRmdbG3Meta } from "D:/oneway/machine-web/pages/about-us/index.vue?macro=true";
import { default as quality_45control_45abilitylEAR7pdjZsMeta } from "D:/oneway/machine-web/pages/about-us/quality-control-ability.vue?macro=true";
import { default as contact_45oldYIVvABcrZpMeta } from "D:/oneway/machine-web/pages/contact-old.vue?macro=true";
import { default as contactbeWD6RZ9qmMeta } from "D:/oneway/machine-web/pages/contact.vue?macro=true";
import { default as downloadBEniKOKFnNMeta } from "D:/oneway/machine-web/pages/download.vue?macro=true";
import { default as indexUBrEBlThtZMeta } from "D:/oneway/machine-web/pages/index.vue?macro=true";
import { default as newsoMPB82g4STMeta } from "D:/oneway/machine-web/pages/news.vue?macro=true";
import { default as _91id_93blnMQFno1YMeta } from "D:/oneway/machine-web/pages/news/[id].vue?macro=true";
import { default as indexTvDqP1KK9IMeta } from "D:/oneway/machine-web/pages/news/index.vue?macro=true";
import { default as product51oOX5s4CLMeta } from "D:/oneway/machine-web/pages/product.vue?macro=true";
import { default as _91cate_93NyhfnepZeRMeta } from "D:/oneway/machine-web/pages/product/[cate].vue?macro=true";
import { default as _91id_93ARiNdlxTKbMeta } from "D:/oneway/machine-web/pages/product/detail/[id].vue?macro=true";
import { default as indexfUpXVuHNhsMeta } from "D:/oneway/machine-web/pages/product/index.vue?macro=true";
export default [
  {
    path: about_45us6Wta0rHXEGMeta?.path ?? "/about-us",
    children: [
  {
    name: company_45profileHjzlV7Evv4Meta?.name ?? "about-us-company-profile",
    path: company_45profileHjzlV7Evv4Meta?.path ?? "company-profile",
    children: [],
    meta: company_45profileHjzlV7Evv4Meta || {},
    alias: company_45profileHjzlV7Evv4Meta?.alias || [],
    redirect: company_45profileHjzlV7Evv4Meta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/about-us/company-profile.vue").then(m => m.default || m)
  },
  {
    name: factory_45production4VeLh2tqinMeta?.name ?? "about-us-factory-production",
    path: factory_45production4VeLh2tqinMeta?.path ?? "factory-production",
    children: [],
    meta: factory_45production4VeLh2tqinMeta || {},
    alias: factory_45production4VeLh2tqinMeta?.alias || [],
    redirect: factory_45production4VeLh2tqinMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/about-us/factory-production.vue").then(m => m.default || m)
  },
  {
    name: faqEeJT1m2LGhMeta?.name ?? "about-us-faq",
    path: faqEeJT1m2LGhMeta?.path ?? "faq",
    children: [],
    meta: faqEeJT1m2LGhMeta || {},
    alias: faqEeJT1m2LGhMeta?.alias || [],
    redirect: faqEeJT1m2LGhMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/about-us/faq.vue").then(m => m.default || m)
  },
  {
    name: index68OmRmdbG3Meta?.name ?? "about-us",
    path: index68OmRmdbG3Meta?.path ?? "",
    children: [],
    meta: index68OmRmdbG3Meta || {},
    alias: index68OmRmdbG3Meta?.alias || [],
    redirect: index68OmRmdbG3Meta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: quality_45control_45abilitylEAR7pdjZsMeta?.name ?? "about-us-quality-control-ability",
    path: quality_45control_45abilitylEAR7pdjZsMeta?.path ?? "quality-control-ability",
    children: [],
    meta: quality_45control_45abilitylEAR7pdjZsMeta || {},
    alias: quality_45control_45abilitylEAR7pdjZsMeta?.alias || [],
    redirect: quality_45control_45abilitylEAR7pdjZsMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/about-us/quality-control-ability.vue").then(m => m.default || m)
  }
],
    name: about_45us6Wta0rHXEGMeta?.name ?? undefined,
    meta: about_45us6Wta0rHXEGMeta || {},
    alias: about_45us6Wta0rHXEGMeta?.alias || [],
    redirect: about_45us6Wta0rHXEGMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: contact_45oldYIVvABcrZpMeta?.name ?? "contact-old",
    path: contact_45oldYIVvABcrZpMeta?.path ?? "/contact-old",
    children: [],
    meta: contact_45oldYIVvABcrZpMeta || {},
    alias: contact_45oldYIVvABcrZpMeta?.alias || [],
    redirect: contact_45oldYIVvABcrZpMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/contact-old.vue").then(m => m.default || m)
  },
  {
    name: contactbeWD6RZ9qmMeta?.name ?? "contact",
    path: contactbeWD6RZ9qmMeta?.path ?? "/contact",
    children: [],
    meta: contactbeWD6RZ9qmMeta || {},
    alias: contactbeWD6RZ9qmMeta?.alias || [],
    redirect: contactbeWD6RZ9qmMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: downloadBEniKOKFnNMeta?.name ?? "download",
    path: downloadBEniKOKFnNMeta?.path ?? "/download",
    children: [],
    meta: downloadBEniKOKFnNMeta || {},
    alias: downloadBEniKOKFnNMeta?.alias || [],
    redirect: downloadBEniKOKFnNMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/download.vue").then(m => m.default || m)
  },
  {
    name: indexUBrEBlThtZMeta?.name ?? "index",
    path: indexUBrEBlThtZMeta?.path ?? "/",
    children: [],
    meta: indexUBrEBlThtZMeta || {},
    alias: indexUBrEBlThtZMeta?.alias || [],
    redirect: indexUBrEBlThtZMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/index.vue").then(m => m.default || m)
  },
  {
    path: newsoMPB82g4STMeta?.path ?? "/news",
    children: [
  {
    name: _91id_93blnMQFno1YMeta?.name ?? "news-id",
    path: _91id_93blnMQFno1YMeta?.path ?? ":id",
    children: [],
    meta: _91id_93blnMQFno1YMeta || {},
    alias: _91id_93blnMQFno1YMeta?.alias || [],
    redirect: _91id_93blnMQFno1YMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/news/[id].vue").then(m => m.default || m)
  },
  {
    name: indexTvDqP1KK9IMeta?.name ?? "news",
    path: indexTvDqP1KK9IMeta?.path ?? "",
    children: [],
    meta: indexTvDqP1KK9IMeta || {},
    alias: indexTvDqP1KK9IMeta?.alias || [],
    redirect: indexTvDqP1KK9IMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/news/index.vue").then(m => m.default || m)
  }
],
    name: newsoMPB82g4STMeta?.name ?? undefined,
    meta: newsoMPB82g4STMeta || {},
    alias: newsoMPB82g4STMeta?.alias || [],
    redirect: newsoMPB82g4STMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/news.vue").then(m => m.default || m)
  },
  {
    path: product51oOX5s4CLMeta?.path ?? "/product",
    children: [
  {
    name: _91cate_93NyhfnepZeRMeta?.name ?? "product-cate",
    path: _91cate_93NyhfnepZeRMeta?.path ?? ":cate",
    children: [],
    meta: _91cate_93NyhfnepZeRMeta || {},
    alias: _91cate_93NyhfnepZeRMeta?.alias || [],
    redirect: _91cate_93NyhfnepZeRMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/product/[cate].vue").then(m => m.default || m)
  },
  {
    name: _91id_93ARiNdlxTKbMeta?.name ?? "product-detail-id",
    path: _91id_93ARiNdlxTKbMeta?.path ?? "detail/:id",
    children: [],
    meta: _91id_93ARiNdlxTKbMeta || {},
    alias: _91id_93ARiNdlxTKbMeta?.alias || [],
    redirect: _91id_93ARiNdlxTKbMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/product/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: indexfUpXVuHNhsMeta?.name ?? "product",
    path: indexfUpXVuHNhsMeta?.path ?? "",
    children: [],
    meta: indexfUpXVuHNhsMeta || {},
    alias: indexfUpXVuHNhsMeta?.alias || [],
    redirect: indexfUpXVuHNhsMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/product/index.vue").then(m => m.default || m)
  }
],
    name: product51oOX5s4CLMeta?.name ?? undefined,
    meta: product51oOX5s4CLMeta || {},
    alias: product51oOX5s4CLMeta?.alias || [],
    redirect: product51oOX5s4CLMeta?.redirect || undefined,
    component: () => import("D:/oneway/machine-web/pages/product.vue").then(m => m.default || m)
  }
]